export const ru = {
    back: 'Назад',
    details: 'Подробности',
    to_trips_list: 'К списку заявок',
};
